import * as React from "react";
import { WebDate } from "../../../../WebDate";
import * as main from "../../main.module.scss";
import * as tt from "./style.module.scss";
export const Timetable = ({ id, widgetFree, widgetPrice }) => {
  return (
    <section className={tt.tt} id={"tt"}>
      <div className="container">
        <h2 className={main.title}>Расписание обучения</h2>
        <div className={tt.wrap}>
          <div className={tt.info}>
            <div className={tt.infoLeft}>
              <div className={tt.btnWrap}>
                <button className={tt.btnDay}><span className={tt.day}>день</span><span className={tt.num}>1</span></button>
                <button className={tt.btnDay}><span className={tt.day}>день</span><span className={tt.num}>2</span></button>
                <button className={tt.btnDay}><span className={tt.day}>день</span><span className={tt.num}>3</span></button>
                <button className={tt.btnDay}><span className={tt.day}>день</span><span className={tt.num}>4</span></button>
                <button className={tt.btnDay}><span className={tt.day}>день</span><span className={tt.num}>5</span></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>

                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>

                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>

                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
                <button className={tt.btnEmpty} aria-label={"btn-empty"}></button>
              </div>
              <ul className={tt.orgList}>
                <li>Длительность урока: <strong>1 час 30 минут</strong></li>
                <li>Уроки начинаются <strong>в 19:00 (Москва)</strong></li>
                <li>Программа для родителей и детей</li>
              </ul>
            </div>
            <div className={tt.infoRight}>
              <h3>Начало марафона <span><WebDate id={id}/></span></h3>
              <ul className={tt.daysList}>
                <li><span>1 день:</span><p>Проблемы образования вашего ребенка</p></li>
                <li><span>2 день:</span><p>Система достижения результата</p></li>
                <li><span>3 день:</span><p>Упражнения, которые понравятся ребенку</p></li>
                <li><span>4 день:</span><p>Годовая программа школы за два месяца</p></li>
                <li><span>5 день:</span><p>План успешного будущего вашего ребенка</p></li>
              </ul>
            </div>
          </div>
          <div className={tt.reg}>
            <div className={tt.form}>
              <h3>Заполните поля и мы отправим доступ на&nbsp;почту</h3>
              { widgetFree }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
